<template>
  <div class="social-step-editor-sidebar-media">
    <shared-step-editor-accordion>
      <shared-step-editor-accordion-item title="Choose Stock Image" @clicked="$emit('stock-tab', $event)" :open="stockOpen">
        <social-step-editor-sidebar-media-images :image="imagePiece.content"  @update="onUpdate" />
      </shared-step-editor-accordion-item>
      <shared-step-editor-accordion-item title="Generate Image (AI)" @clicked="$emit('ai-tab', $event)" :open="aiOpen">
        <social-step-editor-sidebar-a-i-images :image="imagePiece.content"  @update="onUpdate" />
      </shared-step-editor-accordion-item>
      <shared-step-editor-accordion-item title="Upload Image" @clicked="$emit('upload-tab', $event)" :open="uploadOpen">
        <social-step-editor-sidebar-media-file :image="imagePiece.content" @update="onUpdate" />
      </shared-step-editor-accordion-item>
    </shared-step-editor-accordion>
  </div>
</template>

<script>
import SharedStepEditorAccordion from '../../shared/accordion/SharedStepEditorAccordion';
import SharedStepEditorAccordionItem from '../../shared/accordion/SharedStepEditorAccordionItem';
import SocialStepEditorSidebarMediaImages from './SocialStepEditorSidebarMediaImages';
import SocialStepEditorSidebarMediaFile from './SocialStepEditorSidebarMediaFile';
import SocialStepEditorSidebarAIImages from './SocialStepEditorSidebarAIImages.vue';

export default {
  components: {
    SharedStepEditorAccordion,
    SharedStepEditorAccordionItem,
    SocialStepEditorSidebarMediaImages,
    SocialStepEditorSidebarMediaFile,
    SocialStepEditorSidebarAIImages,
  },
  props: {
    imagePiece: Object,
    stockOpen: Boolean,
    aiOpen: Boolean,
    uploadOpen: Boolean,
  },
  methods: {
    onUpdate(image) {
      this.$emit('update', {id: this.imagePiece.id, content: image});
    },
  },
};
</script>

<style lang="scss" scoped>
.social-step-editor-sidebar-media{
  &__alert {
    margin: 16px;
  }
}
</style>
